import React, { useState } from 'react';
import { AuthFacade } from '../facades/AuthFacade';

const Login: React.FC = () => {
    // --- ESTADOS DO COMPONENTE ---
    const [login, setLogin] = useState('');
    const [senha, setSenha] = useState('');
    const [loading, setLoading] = useState(false);
    const [erro, setErro] = useState('');

    const onSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setErro('');

        try {
            const autenticado = await AuthFacade.login(login, senha);
            if (autenticado) {
                window.location.href = '/dashboard';
                return;
            }

            setErro('Falha na autenticação. Verifique suas credenciais ou se o serviço em https://gestjus-api.onrender.com está ativo.');
        } finally {
            setLoading(false);
        }
    };

    // --- VISUAL DA TELA (JSX + TAILWIND) ---
    return (
        <div className="flex min-h-screen font-sans bg-gray-50">

            {/* ========================================================== */}
            {/* LADO ESQUERDO: MARKETING E FUNDO PROFISSIONAL (Aparece só no PC) */}
            {/* ========================================================== */}
            <div className="hidden md:flex md:w-3/5 bg-[#1e3a8a] text-white flex-col justify-center items-center p-12 text-center relative overflow-hidden bg-[url('https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?q=80&w=2000')] bg-cover bg-center">
                <div className="absolute top-0 left-0 w-full h-full bg-[#1e3a8a] opacity-90 z-0"></div>
                <div className="relative z-10 flex flex-col items-center max-w-lg">
                    <h1 className="text-6xl font-extrabold mb-12 tracking-tight">GestJus ⚖️</h1>
                    <h2 className="text-3xl font-light mb-8 text-blue-100 leading-snug">Gestão de Contratos e Processos</h2>
                    <p className="text-xl max-w-lg leading-relaxed text-gray-200">
                        A visão estratégica e financeira do seu sistema jurídico centralizada em uma plataforma inteligente, rápida e 100% segura.
                    </p>
                </div>
            </div>

            {/* ========================================================== */}
            {/* LADO DIREITO: FORMULÁRIO (100% no celular, 40% no PC)      */}
            {/* ========================================================== */}
            <div className="w-full md:w-2/5 flex flex-col justify-between items-center p-6 sm:p-12 bg-white md:bg-gray-50 shadow-2xl md:shadow-none z-20">
                <div className="w-full flex justify-center items-center flex-grow">
                    <div className="w-full max-w-md bg-white p-8 sm:p-10 rounded-2xl md:shadow-xl border border-gray-100">
                        <div className="text-center mb-10">
                            <div className="md:hidden flex justify-center mb-8">
                                <h1 className="text-5xl font-extrabold tracking-tight text-[#1e3a8a]">GestJus ⚖️</h1>
                            </div>
                            <h3 className="text-2xl font-bold text-gray-800">Acesse o Sistema</h3>
                            <p className="text-gray-500 text-sm mt-2">Insira suas credenciais para continuar</p>
                        </div>

                        {erro && (
                            <div className="mb-8 p-4 bg-red-50 border-l-4 border-red-500 text-red-700 rounded-md text-sm font-medium animate-pulse">
                                {erro}
                            </div>
                        )}

                        <form onSubmit={onSubmit} className="space-y-8">
                            <div>
                                <label className="block text-gray-700 text-sm font-bold mb-2">Nome de Usuário (Login)</label>
                                <input
                                    type="text"
                                    value={login}
                                    onChange={(e) => setLogin(e.target.value)}
                                    required
                                    autoComplete="username"
                                    placeholder="Seu login"
                                    className="w-full px-4 py-3.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1e3a8a] focus:border-transparent transition-all bg-gray-50 focus:bg-white"
                                />
                            </div>
                            <div>
                                <label className="block text-gray-700 text-sm font-bold mb-2">Sua Senha Mestra</label>
                                <input
                                    type="password"
                                    value={senha}
                                    onChange={(e) => setSenha(e.target.value)}
                                    required
                                    autoComplete="current-password"
                                    placeholder="••••••"
                                    className="w-full px-4 py-3.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1e3a8a] focus:border-transparent transition-all bg-gray-50 focus:bg-white"
                                />
                            </div>
                            <button
                                type="submit"
                                disabled={loading}
                                className="w-full mt-10 bg-[#1e3a8a] hover:bg-blue-800 text-white font-bold py-4 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg disabled:opacity-70 disabled:cursor-not-allowed flex justify-center items-center text-lg tracking-wide"
                            >
                                {loading ? 'Autenticando...' : 'Entrar no Sistema GestJus'}
                            </button>
                        </form>

                    </div>
                </div>

                <div className="w-full max-w-md mt-10 text-center text-sm text-gray-400">
                    © 2026 GESTJUS. Desenvolvido por ASL Tech / Áidano Lima
                </div>
            </div>
        </div>
    );
};

export default Login;
